export default __webpack_public_path__ + "ab24dcee949b66577259e1d43a6c4306.png";